var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSparkleDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 6.4 6.4",
    style: {
      enableBackground: "new 0 0 6.4 6.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D69AE5;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.5,0.3l0.4,2C4,2.4,4,2.4,4.2,2.5l2,0.4c0.3,0.1,0.3,0.5,0,0.6l-2,0.4C4,4,4,4,3.9,4.2l-0.4,2 C3.4,6.4,3,6.4,2.9,6.1l-0.4-2C2.4,4,2.4,4,2.2,3.9l-2-0.4C0,3.4,0,3,0.3,2.9l2-0.4c0.1,0,0.2-0.1,0.2-0.2l0.4-2C3,0,3.4,0,3.5,0.3z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkleDark);
export default __webpack_public_path__ + "static/media/sparkle-dark.dd83d2a4b191f40f0ced6c5867e3e8a4.svg";
export { ForwardRef as ReactComponent };